module.exports = __webpack_public_path__ + "static/media/GeneralLoading.b88bb926.gif";